<template>
  <main class="wallet-page">
    <NavBar class="wallet-page__nav" :title="$t('homeRedesign.navWallet')" fixed placeholder>
    </NavBar>

    <section class="wallet-summary">
      <p>{{ $t('walletPage.amount') }}</p>
      <div class="wallet-summary__balance">
        <strong>{{ $money(userInfo.money || 0) }}</strong>
      </div>
    </section>

    <div class="wallet-notice">
      <Icon name="info-o" />
      <span>{{ $t('walletPage.notice') }}</span>
    </div>

    <section class="wallet-actions">
      <button type="button" @click="$router.push({ name: 'newWithdraw' })">
        <svg class="wallet-actions__icon wallet-actions__icon--withdraw" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 8V6.5A2.5 2.5 0 0 1 10.5 4h3A2.5 2.5 0 0 1 16 6.5V8"></path>
          <rect x="3" y="8" width="18" height="12" rx="2"></rect>
          <path d="M3 13h18M9 13h6"></path>
        </svg>
        <span>{{ $t('homeRedesign.withdraw') }}</span>
      </button>
      <button type="button" @click="$router.push({ name: 'withdrawList' })">
        <svg class="wallet-actions__icon wallet-actions__icon--history" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 4h11l5 5v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"></path>
          <path d="M7 8h6M7 11h4"></path>
          <circle cx="15" cy="15" r="4"></circle>
          <path d="M15 13.3V15l1.4.9"></path>
        </svg>
        <span>{{ $t('walletPage.withdrawHistory') }}</span>
      </button>
    </section>
  </main>
</template>

<script>
import { Icon, NavBar } from 'vant'
import { mapGetters } from 'vuex'

export default {
  name: 'WalletHome',
  components: {
    Icon,
    NavBar,
  },
  computed: {
    ...mapGetters(['userInfo', 'unitData']),
  },
  created() {
    this.$store.dispatch('getUserInfo')
  },
}
</script>

<style lang="less" scoped>
@accent: var(--color-primary-strong);

.wallet-page {
  width: 100%;
  max-width: 750px;
  min-height: calc(100vh - 82px);
  min-height: calc(100dvh - 82px);
  margin: 0 auto;
  overflow-x: hidden;
  color: var(--color-text);
  background: var(--page-background);
  box-sizing: border-box;
}

.wallet-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 16px 26px;
  box-sizing: border-box;
  background: #ffffff;

  p {
    margin: 0 0 15px;
    color: #b3b3b3;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 22px;
  }

  &__balance {
    display: flex;
    align-items: baseline;
    justify-content: center;
    color: @accent;

    strong {
      font-size: clamp(40px, 10.2vw, 48px);
      font-weight: 700;
      letter-spacing: -1.2px;
      line-height: 1;
    }

  }
}

.wallet-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  box-sizing: border-box;
  color: var(--color-primary-strong);
  background: var(--color-primary-soft);
  font-size: 11px;
  letter-spacing: 0;
  line-height: 18px;

  .van-icon {
    flex: 0 0 auto;
    font-size: 16px;
  }

  span {
    min-width: 0;
    overflow: hidden;
    letter-spacing: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.wallet-actions {
  display: grid;
  grid-template-columns: calc(50% - 3.5px) calc(50% + 3.5px);
  background: #ffffff;

  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 13px;
    padding: 18px 10px 16px;
    color: #555555;
    background: transparent;
    border: 0;
    font: inherit;
    font-size: 10px;
    letter-spacing: 0;

    &+button {
      border-left: 3px solid #ebebeb;
    }
  }

  &__icon {
    width: 30px;
    height: 30px;
    display: block;
    flex: 0 0 auto;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.7;

    &--withdraw {
      color: var(--color-primary);
    }

    &--history {
      color: var(--color-primary);
    }
  }
}

@media (max-width: 360px) {
  .wallet-page {

    /deep/ .wallet-page__nav .van-nav-bar__left {
      padding: 0 15px;
    }

    /deep/ .wallet-page__nav .van-nav-bar__right {
      padding: 0 12px;
    }
  }

  .wallet-notice {
    padding-right: 14px;
    padding-left: 14px;
    font-size: 12px;
  }
}
</style>
